import * as React from 'react';

import * as Settings from '../contexts/settings';
import * as Services from '../../lib/services';
import { createWellspringServiceClient } from '../../lib/serviceClient';

export interface GridRenderProps {
    grid: Services.ConfigurationProjectionLayoutGrid.Grid;
    refresh: () => void;
}

export interface GridProps {
    entityKey: string;
    gridName: string;
    render?: (props: GridRenderProps) => JSX.Element;
}
export function Grid({ render, entityKey, gridName }: GridProps) {
    const [ settings ] = Settings.useSettings();

    const [ serviceClient, setServiceClient ] = React.useState<Services.Configuration.GridServiceClient>();
    React.useEffect(() => {
        setServiceClient(createWellspringServiceClient(Services.Configuration.GridServiceClient, settings.servicesUrl, 'bff.cygnus.configuration.grid'));
    }, [ settings ]);

    const [ context, setContext ] = React.useState(new Services.Configuration.GridContext());
    React.useEffect(() => {(async () => {
        if (!entityKey || !gridName)
            return;

        await serviceClient?.init(context, entityKey, gridName);
        setContext(context.clone());
    })().catch(err => {
        console.error(err)
    })}, [ serviceClient, entityKey, gridName ]);

    const [ grid, setGrid ] = React.useState<Services.ConfigurationProjectionLayoutGrid.Grid>();
    React.useEffect(() => {(async () => {
        if (!serviceClient)
            return;
        if (!context.entityKey || !context.gridName)
            return;

        const grid = await serviceClient.get(context);
        setGrid(grid);
    })().catch(err => {
        console.error(err)
    })}, [ serviceClient, context ]);

    const refresh = () => {(async () => {
        const grid = await serviceClient?.get(context);
        setGrid(grid);
    })()}

    return (
        <React.Fragment>
            {render && (grid ? render({
                grid,
                refresh
            }) : <em>Loading grid...</em>)}
        </React.Fragment>
    );
}

export const useGridXM = (entityKey?: string, gridName?: string) => {
    const [ settings ] = Settings.useSettings();

    const [ serviceClient, setServiceClient ] = React.useState<Services.Configuration.GridServiceClient>();
    React.useEffect(() => {
        setServiceClient(createWellspringServiceClient(Services.Configuration.GridServiceClient, settings.servicesUrl, 'bff.cygnus.configuration.grid'));
    }, [ settings ]);

    const [ coreCacheServiceClient, setCoreCacheServiceClient ] = React.useState<Services.ConfigurationCore.CacheServiceClient>();
    React.useEffect(() => {
        setCoreCacheServiceClient(createWellspringServiceClient(Services.ConfigurationCore.CacheServiceClient, settings.servicesUrl, 'nucleus.configuration.core.cache'));
    }, [ settings ]);

    const [ context, setContext ] = React.useState(new Services.Configuration.GridContext({ entityKey, gridName }));
    React.useEffect(() => {
        setContext(new Services.Configuration.GridContext({ entityKey, gridName }));
    }, [ entityKey, gridName ]);

    const [ grid, setGrid ] = React.useState<Services.ConfigurationProjectionLayoutGrid.Grid>();
    React.useEffect(() => {(async () => {
        if (!serviceClient)
            return;
        if (!coreCacheServiceClient)
            return;
        if (!context.entityKey || !context.gridName)
            return;

        const grid = await serviceClient.get(context);
        setGrid(grid);

        // const coreEntity = await coreCacheServiceClient?.load(context.entityKey);
        // console.log('CORE ENTITY (grid)', coreEntity);
    })().catch(err => {
        console.error(err)
    })}, [ serviceClient, coreCacheServiceClient, context ]);

    const refresh = async () => {
        const grid = await serviceClient?.get(context);
        setGrid(grid);

        // const coreEntity = await coreCacheServiceClient?.load(context.entityKey);
        // console.log('CORE ENTITY (grid)', coreEntity);
    }

    return [ grid, refresh ] as const;
}